import ComposePlugins, { findComposePlugins } from '../plugins/ComposePlugins';
import insertNodeFromExpressionPicker from 'owa-expressions-store/lib/actions/insertNodeFromExpressionPicker';
import { ComposeViewState, getStore } from 'owa-mail-compose-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(insertNodeFromExpressionPicker, actionMessage => {
    const { composeId, wordToReplace, node, range } = actionMessage;

    const composeStore = getStore();
    const viewState: ComposeViewState = composeStore.viewStates.get(composeId);
    const plugins: ComposePlugins = viewState && findComposePlugins(viewState);
    const editorOperationPlugin = plugins && plugins.editorOperation;
    if (editorOperationPlugin) {
        editorOperationPlugin.insertNode(node, wordToReplace, range);
    }
});
